import api from "./api";

const sp = (schemaName) => (schemaName ? { client: schemaName } : {});

// --- WiFiProfile CRUD ---

export const getAllWiFiProfiles = async (schemaName = null) => {
  try {
    const response = await api.get("/wifi-profiles/", { params: sp(schemaName) });
    return response.data.results || response.data;
  } catch (error) {
    console.error("Error fetching WiFi profiles:", error);
    throw error;
  }
};

export const getWiFiProfileById = async (id, schemaName = null, revealSecrets = false) => {
  try {
    const params = sp(schemaName);
    if (revealSecrets) params.reveal_secrets = "true";
    const response = await api.get(`/wifi-profiles/${id}/`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching WiFi profile:", error);
    throw error;
  }
};

export const createWiFiProfile = async (data, schemaName = null) => {
  try {
    const response = await api.post("/wifi-profiles/", data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error creating WiFi profile:", error);
    throw error;
  }
};

export const updateWiFiProfile = async (id, data, schemaName = null) => {
  try {
    const response = await api.patch(`/wifi-profiles/${id}/`, data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error updating WiFi profile:", error);
    throw error;
  }
};

export const deleteWiFiProfile = async (id, schemaName = null) => {
  try {
    const response = await api.delete(`/wifi-profiles/${id}/`, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error deleting WiFi profile:", error);
    throw error;
  }
};

export const approveWiFiProfile = async (id, schemaName = null) => {
  try {
    const response = await api.post(`/wifi-profiles/${id}/approve/`, {}, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error approving WiFi profile:", error);
    throw error;
  }
};

export const denyWiFiProfile = async (id, schemaName = null) => {
  try {
    const response = await api.post(`/wifi-profiles/${id}/deny/`, {}, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error denying WiFi profile:", error);
    throw error;
  }
};

// --- ProbeWiFiProfile CRUD ---

export const getProbeWiFiProfiles = async (probeId, schemaName = null) => {
  try {
    const params = { ...sp(schemaName), probe: probeId };
    const response = await api.get("/probe-wifi-profiles/", { params });
    return response.data.results || response.data;
  } catch (error) {
    console.error("Error fetching probe WiFi assignments:", error);
    throw error;
  }
};

export const getAssignmentsByProfile = async (wifiProfileId, schemaName = null) => {
  try {
    const params = { ...sp(schemaName), wifi_profile: wifiProfileId };
    const response = await api.get("/probe-wifi-profiles/", { params });
    return response.data.results || response.data;
  } catch (error) {
    console.error("Error fetching WiFi profile assignments:", error);
    throw error;
  }
};

export const attachWiFiProfileToProbe = async (data, schemaName = null) => {
  try {
    const response = await api.post("/probe-wifi-profiles/", data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error attaching WiFi profile to probe:", error);
    throw error;
  }
};

export const updateProbeWiFiProfile = async (id, data, schemaName = null) => {
  try {
    const response = await api.patch(`/probe-wifi-profiles/${id}/`, data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error updating probe WiFi assignment:", error);
    throw error;
  }
};

export const detachWiFiProfileFromProbe = async (id, schemaName = null) => {
  try {
    const response = await api.delete(`/probe-wifi-profiles/${id}/`, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error detaching WiFi profile:", error);
    throw error;
  }
};
